import HowToApply from '../components/sections/HowToApply';
import Faqs from '../components/sections/Faqs';
import ApplicationForm from '../components/apply/ApplicationForm';

export default function ApplyPage() {
  return (
    <>
      <section className="bg-hero-glow">
        <div className="container py-14 lg:py-20">
          <div className="max-w-3xl">
            <span className="eyebrow">Applications</span>
            <h1 className="mt-5 text-4xl leading-tight sm:text-5xl">Apply for a programme</h1>
            <p className="mt-6 text-lg leading-relaxed text-brand-900/65">
              Apply online in one step. Fill in your details, upload your documents and we will review your application.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white">
        <div className="section-shell">
          <ApplicationForm />
        </div>
      </section>

      <HowToApply />
      <Faqs />
    </>
  );
}
